module.exports = __webpack_public_path__ + "media/newstyle/images/play_circle-c3b808651f79650d86b97f8ed56363f0.svg";